import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { FACEBOOK_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const FacebookRoundedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={FACEBOOK_ROUNDED_GLYPH} />;
